module.exports = __webpack_public_path__ + "static/media/Bengisu Kuscu.ce5ac6f2.png";